"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thDefaultProps = exports.tdDefaultProps = exports.ROW_HOVER_OUTLINE_WIDTH = exports.ROW_HOVER_OUTLINE_OFFSET = exports.ROW_HOVER_OUTLINE_COLOR = exports.HEADER_SPACING_VERTICAL_REDUCED = exports.HEADER_SPACING_VERTICAL = exports.CELL_SPACING_VERTICAL_REDUCED = exports.CELL_SPACING_VERTICAL = exports.CELL_SPACING_HORIZONTAL = exports.BORDER_WIDTH_OUTER = exports.BORDER_WIDTH_INNER = exports.BORDER_COLOR = exports.BACKGROUND_SHADE_COLOR = exports.BACKGROUND_COLOR_HEADER_STRIPED = exports.BACKGROUND_COLOR_HEADER = void 0;
var HEADER_SPACING_VERTICAL = 'S300';
exports.HEADER_SPACING_VERTICAL = HEADER_SPACING_VERTICAL;
var CELL_SPACING_VERTICAL = 'S300';
exports.CELL_SPACING_VERTICAL = CELL_SPACING_VERTICAL;
var CELL_SPACING_HORIZONTAL = 'S300';
exports.CELL_SPACING_HORIZONTAL = CELL_SPACING_HORIZONTAL;
var HEADER_SPACING_VERTICAL_REDUCED = 'S200';
exports.HEADER_SPACING_VERTICAL_REDUCED = HEADER_SPACING_VERTICAL_REDUCED;
var CELL_SPACING_VERTICAL_REDUCED = 'S200';
exports.CELL_SPACING_VERTICAL_REDUCED = CELL_SPACING_VERTICAL_REDUCED;
var BORDER_COLOR = 'neutral10';
exports.BORDER_COLOR = BORDER_COLOR;
var BORDER_WIDTH_OUTER = 2;
exports.BORDER_WIDTH_OUTER = BORDER_WIDTH_OUTER;
var BORDER_WIDTH_INNER = 1;
exports.BORDER_WIDTH_INNER = BORDER_WIDTH_INNER;
var BACKGROUND_COLOR_HEADER = 'neutral05';
exports.BACKGROUND_COLOR_HEADER = BACKGROUND_COLOR_HEADER;
var BACKGROUND_COLOR_HEADER_STRIPED = 'neutral10';
exports.BACKGROUND_COLOR_HEADER_STRIPED = BACKGROUND_COLOR_HEADER_STRIPED;
var BACKGROUND_SHADE_COLOR = 'neutral05';
exports.BACKGROUND_SHADE_COLOR = BACKGROUND_SHADE_COLOR;
var ROW_HOVER_OUTLINE_COLOR = 'primary70';
exports.ROW_HOVER_OUTLINE_COLOR = ROW_HOVER_OUTLINE_COLOR;
var ROW_HOVER_OUTLINE_WIDTH = 2;
exports.ROW_HOVER_OUTLINE_WIDTH = ROW_HOVER_OUTLINE_WIDTH;
var ROW_HOVER_OUTLINE_OFFSET = -1;
exports.ROW_HOVER_OUTLINE_OFFSET = ROW_HOVER_OUTLINE_OFFSET;
var thDefaultProps = {
  textAlign: 'left'
};
exports.thDefaultProps = thDefaultProps;
var tdDefaultProps = {
  textAlign: 'left',
  verticalAlign: 'middle'
};
exports.tdDefaultProps = tdDefaultProps;